import { ConversationAtomType } from 'src/types/generic';
import { ISendConversationPayloadType } from 'src/types/serviceResponseTypes';
import { TUserInputType } from '../hooks/network/useSendConversation';

/**
 * Util to prepare send message endpoint payload
 */
export const prepareConversationPayload = (
  conversations: ConversationAtomType,
  selectedOption: string,
  bookCode?: string,
  userInputType?: TUserInputType
): ISendConversationPayloadType => {
  const messagesLength = conversations.data?.messages?.length;
  const previousMessage = conversations.data?.messages?.[messagesLength ? messagesLength - 1 : 0];

  const isValidInputChoice =
    userInputType && userInputType === 'multiple_choice'
      ? true
      : previousMessage?.choices?.some((choice) => choice.key === selectedOption.toUpperCase());

  return {
    conversation_id: conversations.data?.id ?? 0,
    content_type: isValidInputChoice ? 'multiple_choice' : 'single_input',
    content: isValidInputChoice ? selectedOption.toUpperCase() : selectedOption,
    book_code: bookCode,
  };
};
